import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const API = axios.create({ baseURL: process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3001/api' });
const ATTRS = ['sweet','salty','sour','bitter','umami','heat','aroma_intensity'];
const ATTR_LABELS = { sweet:'Sweet', salty:'Salty', sour:'Sour', bitter:'Bitter', umami:'Umami', heat:'Heat', aroma_intensity:'Aroma' };
const ATTR_COLORS = { sweet:'#e91e63', salty:'#2196f3', sour:'#cddc39', bitter:'#795548', umami:'#9c27b0', heat:'#f44336', aroma_intensity:'#ff9800' };

// ─── TAB 1: BASE INGREDIENT MASTER ───
export default function BaseIngredients() {
  const [list, setList] = useState([]);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState(null);
  const [showAdd, setShowAdd] = useState(false);

  const load = () => API.get('/flavor/base-ingredients').then(r => setList(r.data)).catch(() => toast.error('Load failed'));
  useEffect(() => { load(); }, []);

  const blank = { name:'', sweet:0, salty:0, sour:0, bitter:0, umami:0, heat:0, aroma_intensity:0, notes:'' };

  const save = async () => {
    if (!form.name?.trim()) return toast.error('Name required');
    try {
      if (editId) { await API.put(`/flavor/base-ingredients/${editId}`, form); toast.success('Updated'); }
      else { await API.post('/flavor/base-ingredients', form); toast.success('Added'); }
      setEditId(null); setShowAdd(false); setForm(null); load();
    } catch(e) { toast.error(e.response?.data?.error || 'Failed'); }
  };

  const del = async (id, name) => {
    if (!window.confirm(`Delete "${name}" from master? Seasonings using it will lose this component.`)) return;
    await API.delete(`/flavor/base-ingredients/${id}`); toast.success('Deleted'); load();
  };

  const NumCell = ({ field }) => (
    <input type="number" min="0" max="10" step="0.5" value={form[field]}
      onChange={e => setForm({ ...form, [field]: parseFloat(e.target.value)||0 })}
      style={{ width: 52, textAlign: 'center' }} className="form-input" />
  );

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div className="card-title" style={{ margin: 0 }}>Base Ingredient Master ({list.length})</div>
        <button className="btn btn-primary btn-sm" onClick={() => { setShowAdd(true); setEditId(null); setForm({ ...blank }); }}>+ Add Base Ingredient</button>
      </div>
      <table style={{ width: '100%' }}>
        <thead><tr>
          <th>Name</th>
          {ATTRS.map(a => <th key={a} style={{ textAlign: 'center', fontSize: 10 }}>{ATTR_LABELS[a]}</th>)}
          <th>Notes</th><th></th>
        </tr></thead>
        <tbody>
          {(showAdd && form) && (
            <tr style={{ background: 'var(--bg-hover, #faf5fa)' }}>
              <td><input className="form-input" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} placeholder="e.g. Cumin Powder" style={{ width: 140 }} /></td>
              {ATTRS.map(a => <td key={a} style={{ textAlign:'center' }}><NumCell field={a} /></td>)}
              <td><input className="form-input" value={form.notes} onChange={e=>setForm({...form,notes:e.target.value})} style={{ width: 110 }} /></td>
              <td style={{ whiteSpace: 'nowrap' }}>
                <button className="btn btn-primary btn-sm" onClick={save}>✓</button>{' '}
                <button className="btn btn-secondary btn-sm" onClick={()=>{setShowAdd(false);setForm(null);}}>×</button>
              </td>
            </tr>
          )}
          {list.map(b => editId === b.id && form ? (
            <tr key={b.id} style={{ background: 'var(--bg-hover, #faf5fa)' }}>
              <td><input className="form-input" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} style={{ width: 140 }} /></td>
              {ATTRS.map(a => <td key={a} style={{ textAlign:'center' }}><NumCell field={a} /></td>)}
              <td><input className="form-input" value={form.notes} onChange={e=>setForm({...form,notes:e.target.value})} style={{ width: 110 }} /></td>
              <td style={{ whiteSpace: 'nowrap' }}>
                <button className="btn btn-primary btn-sm" onClick={save}>✓</button>{' '}
                <button className="btn btn-secondary btn-sm" onClick={()=>{setEditId(null);setForm(null);}}>×</button>
              </td>
            </tr>
          ) : (
            <tr key={b.id}>
              <td style={{ fontWeight: 600 }}>{b.name}</td>
              {ATTRS.map(a => (
                <td key={a} style={{ textAlign: 'center' }}>
                  <span style={{ fontWeight: 700, color: b[a] > 0 ? ATTR_COLORS[a] : 'var(--text-muted)' }}>{b[a] || '—'}</span>
                </td>
              ))}
              <td style={{ fontSize: 11, color: 'var(--text-muted)' }}>{b.notes}</td>
              <td style={{ whiteSpace: 'nowrap' }}>
                <button className="btn btn-secondary btn-sm" onClick={() => { setEditId(b.id); setShowAdd(false); setForm({ ...b }); }}>Edit</button>{' '}
                <button className="btn btn-danger btn-sm" onClick={() => del(b.id, b.name)}>×</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

